import { render, staticRenderFns } from "./bet-take.vue?vue&type=template&id=648a3934&scoped=true&"
import script from "./bet-take.vue?vue&type=script&lang=js&"
export * from "./bet-take.vue?vue&type=script&lang=js&"
import style0 from "./bet-take.vue?vue&type=style&index=0&id=648a3934&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "648a3934",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('648a3934')) {
      api.createRecord('648a3934', component.options)
    } else {
      api.reload('648a3934', component.options)
    }
    module.hot.accept("./bet-take.vue?vue&type=template&id=648a3934&scoped=true&", function () {
      api.rerender('648a3934', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/chicken-road/bet-take.vue"
export default component.exports